import { TextField } from "@material-ui/core";

export default function OutlinedInput(props) {
  return <TextField {...props} variant="outlined" margin="dense" />;
}
